// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppSearch } from "./app";
import type { SearchAppsWithDeactivatedOwnerResponse } from "./app";
import type { SearchAppsWithDeactivatedOwnerRequest } from "./app";
import type { GetInactiveOwnersCountsResponse } from "./app";
import type { GetInactiveOwnersCountsRequest } from "./app";
import type { SearchAppsExpandedResponse } from "./app";
import type { SearchAppsExpandedRequest } from "./app";
import type { SearchAppsResponse } from "./app";
import type { SearchAppsRequest } from "./app";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Apps } from "./app";
import type { UpliftAppUsersResponse } from "./app";
import type { UpliftAppUsersRequest } from "./app";
import type { SetAppIconResponse } from "./app";
import type { SetAppIconRequest } from "./app";
import type { DeleteAppResponse } from "./app";
import type { DeleteAppRequest } from "./app";
import type { UpdateAppResponse } from "./app";
import type { UpdateAppRequest } from "./app";
import type { CreateAppWithUnmanagedRequest } from "./app";
import type { CreateAppWithConnectorRequest } from "./app";
import type { CreateAppResponse } from "./app";
import type { CreateAppRequest } from "./app";
import type { ListAppsResponse } from "./app";
import type { ListAppsRequest } from "./app";
import type { MultiGetAppResponse } from "./app";
import type { MultiGetAppRequest } from "./app";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAppResponse } from "./app";
import type { GetAppRequest } from "./app";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.Apps
 */
export interface IAppsClient {
    /**
     * Get an app by ID.
     *
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetAppRequest) returns (c1.api.app.v1.GetAppResponse);
     */
    get(input: GetAppRequest, options?: RpcOptions): UnaryCall<GetAppRequest, GetAppResponse>;
    /**
     * @generated from protobuf rpc: MultiGet(c1.api.app.v1.MultiGetAppRequest) returns (c1.api.app.v1.MultiGetAppResponse);
     */
    multiGet(input: MultiGetAppRequest, options?: RpcOptions): UnaryCall<MultiGetAppRequest, MultiGetAppResponse>;
    /**
     * List all apps.
     *
     * @generated from protobuf rpc: List(c1.api.app.v1.ListAppsRequest) returns (c1.api.app.v1.ListAppsResponse);
     */
    list(input: ListAppsRequest, options?: RpcOptions): UnaryCall<ListAppsRequest, ListAppsResponse>;
    /**
     * Create a new manual app without a connector.
     *
     * @generated from protobuf rpc: Create(c1.api.app.v1.CreateAppRequest) returns (c1.api.app.v1.CreateAppResponse);
     */
    create(input: CreateAppRequest, options?: RpcOptions): UnaryCall<CreateAppRequest, CreateAppResponse>;
    /**
     * Create a new app with a connector.
     *
     * @generated from protobuf rpc: CreateWithConnector(c1.api.app.v1.CreateAppWithConnectorRequest) returns (c1.api.app.v1.CreateAppResponse);
     */
    createWithConnector(input: CreateAppWithConnectorRequest, options?: RpcOptions): UnaryCall<CreateAppWithConnectorRequest, CreateAppResponse>;
    /**
     * Create an app from an unmanaged app (promote), with or without a connector.
     *
     * @generated from protobuf rpc: CreateWithUnmanagedApp(c1.api.app.v1.CreateAppWithUnmanagedRequest) returns (c1.api.app.v1.CreateAppResponse);
     */
    createWithUnmanagedApp(input: CreateAppWithUnmanagedRequest, options?: RpcOptions): UnaryCall<CreateAppWithUnmanagedRequest, CreateAppResponse>;
    /**
     * Update an existing app.
     *
     * @generated from protobuf rpc: Update(c1.api.app.v1.UpdateAppRequest) returns (c1.api.app.v1.UpdateAppResponse);
     */
    update(input: UpdateAppRequest, options?: RpcOptions): UnaryCall<UpdateAppRequest, UpdateAppResponse>;
    /**
     * Delete an app.
     *
     * @generated from protobuf rpc: Delete(c1.api.app.v1.DeleteAppRequest) returns (c1.api.app.v1.DeleteAppResponse);
     */
    delete(input: DeleteAppRequest, options?: RpcOptions): UnaryCall<DeleteAppRequest, DeleteAppResponse>;
    /**
     * Set the icon for an app.
     *
     * @generated from protobuf rpc: SetAppIcon(c1.api.app.v1.SetAppIconRequest) returns (c1.api.app.v1.SetAppIconResponse);
     */
    setAppIcon(input: SetAppIconRequest, options?: RpcOptions): UnaryCall<SetAppIconRequest, SetAppIconResponse>;
    /**
     * Uplift app users.
     *
     * @generated from protobuf rpc: UpliftAppUsers(c1.api.app.v1.UpliftAppUsersRequest) returns (c1.api.app.v1.UpliftAppUsersResponse);
     */
    upliftAppUsers(input: UpliftAppUsersRequest, options?: RpcOptions): UnaryCall<UpliftAppUsersRequest, UpliftAppUsersResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.Apps
 */
export class AppsClient implements IAppsClient, ServiceInfo {
    typeName = Apps.typeName;
    methods = Apps.methods;
    options = Apps.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get an app by ID.
     *
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetAppRequest) returns (c1.api.app.v1.GetAppResponse);
     */
    get(input: GetAppRequest, options?: RpcOptions): UnaryCall<GetAppRequest, GetAppResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppRequest, GetAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MultiGet(c1.api.app.v1.MultiGetAppRequest) returns (c1.api.app.v1.MultiGetAppResponse);
     */
    multiGet(input: MultiGetAppRequest, options?: RpcOptions): UnaryCall<MultiGetAppRequest, MultiGetAppResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<MultiGetAppRequest, MultiGetAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List all apps.
     *
     * @generated from protobuf rpc: List(c1.api.app.v1.ListAppsRequest) returns (c1.api.app.v1.ListAppsResponse);
     */
    list(input: ListAppsRequest, options?: RpcOptions): UnaryCall<ListAppsRequest, ListAppsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppsRequest, ListAppsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a new manual app without a connector.
     *
     * @generated from protobuf rpc: Create(c1.api.app.v1.CreateAppRequest) returns (c1.api.app.v1.CreateAppResponse);
     */
    create(input: CreateAppRequest, options?: RpcOptions): UnaryCall<CreateAppRequest, CreateAppResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAppRequest, CreateAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a new app with a connector.
     *
     * @generated from protobuf rpc: CreateWithConnector(c1.api.app.v1.CreateAppWithConnectorRequest) returns (c1.api.app.v1.CreateAppResponse);
     */
    createWithConnector(input: CreateAppWithConnectorRequest, options?: RpcOptions): UnaryCall<CreateAppWithConnectorRequest, CreateAppResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAppWithConnectorRequest, CreateAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create an app from an unmanaged app (promote), with or without a connector.
     *
     * @generated from protobuf rpc: CreateWithUnmanagedApp(c1.api.app.v1.CreateAppWithUnmanagedRequest) returns (c1.api.app.v1.CreateAppResponse);
     */
    createWithUnmanagedApp(input: CreateAppWithUnmanagedRequest, options?: RpcOptions): UnaryCall<CreateAppWithUnmanagedRequest, CreateAppResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAppWithUnmanagedRequest, CreateAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update an existing app.
     *
     * @generated from protobuf rpc: Update(c1.api.app.v1.UpdateAppRequest) returns (c1.api.app.v1.UpdateAppResponse);
     */
    update(input: UpdateAppRequest, options?: RpcOptions): UnaryCall<UpdateAppRequest, UpdateAppResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAppRequest, UpdateAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete an app.
     *
     * @generated from protobuf rpc: Delete(c1.api.app.v1.DeleteAppRequest) returns (c1.api.app.v1.DeleteAppResponse);
     */
    delete(input: DeleteAppRequest, options?: RpcOptions): UnaryCall<DeleteAppRequest, DeleteAppResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAppRequest, DeleteAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Set the icon for an app.
     *
     * @generated from protobuf rpc: SetAppIcon(c1.api.app.v1.SetAppIconRequest) returns (c1.api.app.v1.SetAppIconResponse);
     */
    setAppIcon(input: SetAppIconRequest, options?: RpcOptions): UnaryCall<SetAppIconRequest, SetAppIconResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetAppIconRequest, SetAppIconResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Uplift app users.
     *
     * @generated from protobuf rpc: UpliftAppUsers(c1.api.app.v1.UpliftAppUsersRequest) returns (c1.api.app.v1.UpliftAppUsersResponse);
     */
    upliftAppUsers(input: UpliftAppUsersRequest, options?: RpcOptions): UnaryCall<UpliftAppUsersRequest, UpliftAppUsersResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpliftAppUsersRequest, UpliftAppUsersResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppSearch
 */
export interface IAppSearchClient {
    /**
     * Search apps based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search(c1.api.app.v1.SearchAppsRequest) returns (c1.api.app.v1.SearchAppsResponse);
     */
    search(input: SearchAppsRequest, options?: RpcOptions): UnaryCall<SearchAppsRequest, SearchAppsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppsExpanded(c1.api.app.v1.SearchAppsExpandedRequest) returns (c1.api.app.v1.SearchAppsExpandedResponse);
     */
    searchAppsExpanded(input: SearchAppsExpandedRequest, options?: RpcOptions): UnaryCall<SearchAppsExpandedRequest, SearchAppsExpandedResponse>;
    /**
     * @generated from protobuf rpc: GetInactiveOwnersCounts(c1.api.app.v1.GetInactiveOwnersCountsRequest) returns (c1.api.app.v1.GetInactiveOwnersCountsResponse);
     */
    getInactiveOwnersCounts(input: GetInactiveOwnersCountsRequest, options?: RpcOptions): UnaryCall<GetInactiveOwnersCountsRequest, GetInactiveOwnersCountsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppsWithDeactivatedOwner(c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest) returns (c1.api.app.v1.SearchAppsWithDeactivatedOwnerResponse);
     */
    searchAppsWithDeactivatedOwner(input: SearchAppsWithDeactivatedOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppsWithDeactivatedOwnerRequest, SearchAppsWithDeactivatedOwnerResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppSearch
 */
export class AppSearchClient implements IAppSearchClient, ServiceInfo {
    typeName = AppSearch.typeName;
    methods = AppSearch.methods;
    options = AppSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search apps based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search(c1.api.app.v1.SearchAppsRequest) returns (c1.api.app.v1.SearchAppsResponse);
     */
    search(input: SearchAppsRequest, options?: RpcOptions): UnaryCall<SearchAppsRequest, SearchAppsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppsRequest, SearchAppsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppsExpanded(c1.api.app.v1.SearchAppsExpandedRequest) returns (c1.api.app.v1.SearchAppsExpandedResponse);
     */
    searchAppsExpanded(input: SearchAppsExpandedRequest, options?: RpcOptions): UnaryCall<SearchAppsExpandedRequest, SearchAppsExpandedResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppsExpandedRequest, SearchAppsExpandedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInactiveOwnersCounts(c1.api.app.v1.GetInactiveOwnersCountsRequest) returns (c1.api.app.v1.GetInactiveOwnersCountsResponse);
     */
    getInactiveOwnersCounts(input: GetInactiveOwnersCountsRequest, options?: RpcOptions): UnaryCall<GetInactiveOwnersCountsRequest, GetInactiveOwnersCountsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetInactiveOwnersCountsRequest, GetInactiveOwnersCountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppsWithDeactivatedOwner(c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest) returns (c1.api.app.v1.SearchAppsWithDeactivatedOwnerResponse);
     */
    searchAppsWithDeactivatedOwner(input: SearchAppsWithDeactivatedOwnerRequest, options?: RpcOptions): UnaryCall<SearchAppsWithDeactivatedOwnerRequest, SearchAppsWithDeactivatedOwnerResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppsWithDeactivatedOwnerRequest, SearchAppsWithDeactivatedOwnerResponse>("unary", this._transport, method, opt, input);
    }
}
